import { ElMessage } from "element-plus";
import { MessageOptions, MessageHandle, MessageProps } from "element-plus/es/components/message";

type LocalConfig = Partial<Omit<MessageOptions, "message">>;

interface Notification {
  notify(config: MessageOptions): void;
  notifyWarning: (message: string, config?: LocalConfig) => MessageHandle;
  notifySuccess: (message: string, config?: LocalConfig) => MessageHandle;
  notifyError: (message: string, config?: LocalConfig) => MessageHandle;
  notifyInfo: (message: string, config?: LocalConfig) => MessageHandle;
}

export default function useNotifications(): Notification {
  const notify = (config: MessageOptions) => {
    ElMessage(config);
  };

  const notifyBuilder = (type: MessageProps["type"]): ((message: string, config?: LocalConfig) => MessageHandle) => {
    const buildMessage = (message: string, config?: LocalConfig): MessageHandle =>
      ElMessage({ ...config, message, type, showClose: true });
    return buildMessage;
  };

  const notifyWarning = notifyBuilder("warning");
  const notifySuccess = notifyBuilder("success");
  const notifyError = notifyBuilder("error");
  const notifyInfo = notifyBuilder("info");

  return {
    notify,
    notifyWarning,
    notifySuccess,
    notifyError,
    notifyInfo,
  };
}
